export function isLink(text: string) {
  // Regular expression to match common link patterns
  const linkRegex = /^(http[s]?:\/\/|www\.)\S+/i;

  // Use the test method to check if the text matches the link pattern
  return linkRegex.test(text);
}

/** First URL inside free text (for Copy Link). */
export function extractFirstUrl(text: string): string | null {
  if (!text) return null;
  const match = text.match(/https?:\/\/[^\s<>"']+/i) || text.match(/\bwww\.[^\s<>"']+/i);
  if (!match?.[0]) return null;
  // Trim trailing punctuation commonly stuck to URLs in chat
  return match[0].replace(/[),.!?;:]+$/g, "");
}

/** Whole message is a single URL — not a paragraph that happens to contain one. */
export function isBareHttpUrl(text: string): boolean {
  const s = String(text || "").trim();
  if (!s) return false;
  const url = extractFirstUrl(s);
  if (!url) return false;
  return s === url || s.replace(/[),.;]+$/g, "") === url;
}
